

























import {computed, defineComponent, ref, useFetch} from '@nuxtjs/composition-api';
import {useAddresses} from '~/modules/customer/composables/useAddresses';
import {Country, CustomerAddress} from '~/modules/GraphQL/types';

import Modal from '~/components/Palmers/BaseComponents/Modal/Modal.vue';
import ShippingAddressForm from '~/components/Palmers/Checkout/ShippingAddressForm.vue';
import {
  addressFromApiToForm,
  fromAddressAccountToAddressShipping,
  getInitialCheckoutAddressForm
} from '~/helpers/checkout/address';
import {useCountrySearch} from '~/composables';
import {PropType} from 'vue';
import userAddressesGetters from '~/modules/customer/getters/userAddressesGetters';
import addressGetter from "~/modules/customer/getters/addressGetter";

export default defineComponent({
  name: 'AddressNew',
  components: {
    Modal,
    ShippingAddressForm,
  },

  props: {
    visible: {
      type: Boolean,
      required: true,
    },
    countries: {
      type: Array as PropType<Country[]>,
      required: true,
    },
    isUpdate: {
      type: Boolean,
      default: false,
    },
    addressToUpdate: {
      type: Object,
      default: {},
    },
    addressId: {
      type: [Number, Boolean],
      required: false,
    },
    setShippingAndBilling: {
      type: Function,
      required: true
    }
  },
  setup(props, {emit}) {
    const country = ref<Country | null>(null);

    const {search: searchCountry} = useCountrySearch();

    const {save: saveAddresses, load: loadAddress, update: updateAddress} = useAddresses();

    const address = ref(null);
    const numericAddressId = props.addressId && props.addressId !== 0 ? Number(props.addressId) : null;

    const addNewAddressForm = ref(getInitialCheckoutAddressForm());

    const changeShippingDetails = (field: string, value: string) => {
      addNewAddressForm.value = {
        ...addNewAddressForm.value,
        [field]: value,
      };
    };

    const addNewAddress = async () => {
      await saveAddresses({
        // @ts-ignore
        address: {
          ...addNewAddressForm.value,
          default_shipping: true,
          default_billing: true
        },
      });
      emit('fetch');
      emit('close');

      // @ts-ignore
      props.setShippingAndBilling(fromAddressAccountToAddressShipping(addNewAddressForm.value));
    };

    useFetch(async () => {
      if (props.isUpdate && numericAddressId && !props.addressToUpdate) {
        const addressesData = await loadAddress();
        //@ts-ignore
        addNewAddressForm.value = userAddressesGetters
          .getAddresses(addressesData)
          .find(({id}) => id === numericAddressId);

      }else if(props.addressToUpdate) {
        //@ts-ignore
        addNewAddressForm.value = props.addressToUpdate;
      }
      country.value = await searchCountry({id: addNewAddressForm.value.country_code});
    });

    const update = async () => {
      // @ts-ignore
      await updateAddress({address: {...addNewAddressForm.value, id: numericAddressId}});
      emit('close');
      emit('fetch');
    };

    const changeCountry = async (id: string) => {
      changeShippingDetails('country_code', id);
      country.value = await searchCountry({id});
    };

    const regionInformation = computed(() => addressGetter.regionList(country.value));

    return {
      addNewAddressForm,
      address,
      update,
      changeShippingDetails,
      changeCountry,
      addNewAddress,
      regionInformation
    };
  },
});
